














































import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import Modal from '@/main-components/common/modal/Modal.vue';
import QuestionBankFilter from './QuestionBankFilter.vue';
import QuestionBankContent from './QuestionBankContent.vue';
import QuestionStore, {
  FetchQuestionsParams,
  QuestionStoreInterface,
} from '@/resource/question/questions.store';
import {
  Question,
  QuestionObjective,
} from '@/resource/question/question.model';
import { Collection } from '@/resource/collection/collection.model';
import { OnSubmitReturn } from '@/utils/form/form-input-typing';
import SubjectStore, {
  SubjectStoreInterface,
} from '@/resource/subject/subject.store';
import QuestionBankTotalItem from './question-bank-item/QuestionBankTotalItem.vue';
import { QuestionLanguage } from '@/resource/subject/subject.model';
import MainButton from '@/main-components/common/MainButton.vue';
import { randomizeObjAnswerPosition } from '@/components/question-editor/new-editor/new-editor.util';

@Component({
  components: {
    Modal,
    QuestionBankFilter,
    QuestionBankContent,
    QuestionBankTotalItem,
    MainButton,
  },
})
export default class QuestionBank extends Vue {
  @Inject('addQuestionToPaper')
  addQuestionToPaper!: (
    questionId: number,
    answerPosition: number,
    isSubjective: boolean,
    languages: QuestionLanguage[],
  ) => Promise<void>;

  @Prop({ required: true })
  paper: Collection;

  questionStore: QuestionStoreInterface = QuestionStore;
  subjectStore: SubjectStoreInterface = SubjectStore;

  openModal: any = null;
  closeModal: any = null;
  isLoading = false;

  questionsFilter: FetchQuestionsParams = {
    subjectUuid: 'english',
    level: 0,
    chapterIds: [],
    languages: [],
    difficulties: [],
    keyword: '',
    sortBy: '',
  };

  get questions() {
    const questions: Question[] = [];
    this.questionStore.questions.map(question => {
      const answerPosition = this.answerPosition(question);
      questions.push({ ...question, answerPosition });
    });
    return questions;
  }

  get questionCount() {
    return this.questionStore.questionCount;
  }

  get selectedSubject() {
    return this.subjectStore.subject;
  }

  get isSubjective() {
    return this.questionStore.isSubjective;
  }

  get isLastPage() {
    const { pagination } = this.questionStore;

    if (this.questions.length >= pagination.totalRecords) {
      return true;
    } else {
      return false;
    }
  }

  answerPosition(question: Question) {
    if (!this.isSubjective) {
      const questionObjective = question as QuestionObjective;
      if (questionObjective.answers.length > 1) {
        const correctAnswerPosition = questionObjective.answers.findIndex(
          answer => answer.isCorrect,
        );

        return correctAnswerPosition > 0 ? correctAnswerPosition : 0;
      }
    }

    return randomizeObjAnswerPosition(question, this.isSubjective);
  }

  created() {
    if (this.paper && this.paper.subject) {
      this.questionsFilter.subjectUuid = this.paper.subject.uuid;
    }
  }

  mounted() {
    this.$emit('openQuestionBankModalAdd', this.openQuestionbankModal);
  }

  async openQuestionbankModal() {
    // NOTE: Reset filters
    this.questionsFilter.chapterIds = [];
    this.questionsFilter.languages = [];
    this.questionsFilter.difficulties = [];
    this.questionsFilter.level = 0;
    this.questionsFilter.keyword = '';
    this.questionsFilter.sortBy = '';

    this.openModal && this.openModal();
    await this.fetchQuestions(true);
  }

  openModalAdd(openModal: any) {
    this.openModal = openModal;
  }

  closeModalAdd(closeModal: any) {
    this.closeModal = closeModal;
  }

  async fetchQuestions(
    isResetPagination: boolean,
  ): Promise<OnSubmitReturn | null> {
    if (this.isLoading) return null;
    this.isLoading = true;

    if (isResetPagination) {
      this.questionStore.pagination.page = 1;
      this.questionStore.pagination.isResetPage = true;
      this.questionStore.resetQuestions();

      await this.subjectStore.fetchSubject({
        subjectUuid: this.questionsFilter.subjectUuid,
        subjectType: null,
      });
      this.questionStore.fetchQuestionsCount(this.questionsFilter);
    } else {
      const { pagination } = this.questionStore;

      if (pagination.page >= pagination.totalPages) {
        this.isLoading = false;

        return null;
      }

      this.questionStore.pagination.page += 1;
    }

    await this.questionStore.fetchQuestions(this.questionsFilter);

    this.isLoading = false;

    if (this.questionStore.error) {
      this.$sendMpEvent({
        event: this.$mp_value.ErrorBankSearch,
        properties: {
          error: this.questionStore.error.message,
        },
      });

      return { error: this.questionStore.error };
    } else {
      if (isResetPagination) {
        this.$sendMpEvent({
          event: this.$mp_value.bankSearch,
          properties: {
            ...this.questionsFilter,
            isSubjective: this.isSubjective,
            totalQuestions: this.questions.length,
          },
        });
      } else {
        this.$sendMpEvent({
          event: this.$mp_value.bankScrollMore,
          properties: {
            ...this.questionsFilter,
            isSubjective: this.isSubjective,
            totalQuestions: this.questions.length,
          },
        });
      }
      return null;
    }
  }

  async changeIsSubjective(isSubjective: boolean) {
    this.questionStore.changeIsSubjective(isSubjective);
    await this.fetchQuestions(true);
  }

  async addMultipleQuestions() {
    for (const question of this.questions) {
      await this.addQuestionToPaper(
        question.id,
        question.answerPosition || 0,
        this.isSubjective,
        question.languages,
      );
    }
  }
}
